import { MarketLocaleType, MarketType } from '../types/administrationTypes';

export const getMarketLocale = (market: MarketType): MarketLocaleType => {
  //return 'sv-SE';

  switch (market) {
    case 'M_FI':
      return 'de-DE';
    case 'M_SE':
      return 'sv-SE';
    case 'M_NO':
      return 'nb-NO';
    case 'M_DK':
      return 'da-DK';
    case 'M_UK':
      return 'en-GB';
    case 'M_IE':
      return 'ga-IE';
    default:
      return 'de-DE';
  }
};
